import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../navbar/Navbar';
import ChatModal from '../chat/ChatModal'
import Footer from '../footer/Footer';
import Hero from './Hero';
import FifteenYears from './FifteenYears';
import SmoothScroll from '../public/SmoothScroll';
import StampButton from '../public/StampButton';
import Reveal from '../public/Reveal';
import { useAuth } from '../../context/AuthContext';

function Landingpage() {
    const [isOpen, setIsOpen] = useState(false);
    const [isChatOpen, setIsChatOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const { isAuthenticated, loading } = useAuth();

    // Check for active session and redirect to dashboard if logged in
    useEffect(() => {
        // Only redirect if we're on the root path '/' (not login/signup pages)
        // And if authentication check has completed (not loading)
        if (location.pathname === '/' && !loading && isAuthenticated) {
            navigate('/dashboard');
        }
    }, [isAuthenticated, loading, navigate, location.pathname]);

    useEffect(() => {
        setIsOpen(false);
    }, [location.pathname]);

    // "Ask JPRO" links from other pages land on /?ask=1 and open the chat.
    useEffect(() => {
        if (new URLSearchParams(location.search).get('ask') === '1') {
            setIsChatOpen(true);
            navigate(location.pathname, { replace: true });
        }
    }, [location.search, location.pathname, navigate]);

    const isHome = location.pathname === '/';

    return (
        <div className="public-site relative min-h-screen flex flex-col">
            <SmoothScroll />

            {/* Masthead */}
            <header className="relative z-30 w-full">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-2">
                    <Navbar isOpen={isOpen} setIsOpen={setIsOpen} />
                </div>
            </header>

            <main className={`relative z-10 flex-grow w-full ${isHome ? '' : 'flex items-center justify-center'}`}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
                    {isHome ? (
                        <>
                            <Hero setIsChatOpen={setIsChatOpen} />
                            <FifteenYears />
                            <section className="border-t border-ink/15 py-20 dark:border-paper/15">
                                <Reveal className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-end">
                                    <h2 className="max-w-2xl font-news text-[36px] leading-[1.1] tracking-[-0.015em] sm:text-[44px]">
                                        Fifteen years is a long time to be right.{" "}
                                        <span className="italic text-ink/55 dark:text-paper/55">JPRO helps you stay that way.</span>
                                    </h2>
                                    <StampButton onClick={() => setIsChatOpen(true)}>Ask JPRO</StampButton>
                                </Reveal>
                            </section>
                        </>
                    ) : (
                        <Outlet />
                    )}
                </div>
            </main>

            <div className="relative z-10">
                <Footer />
            </div>

            <ChatModal isOpen={isChatOpen} setIsOpen={setIsChatOpen} />
        </div>
    );
}

export default Landingpage;